module.exports = __webpack_public_path__ + "assets/img/rule_1.6c8d2f3d.png";